import { formatCurrency } from "../../../utils/formatters";
import { Building2 } from "lucide-react";

const TopHubsTable = ({ hubs }) => (
  <div className="bg-bg-surface border border-border rounded-xl overflow-hidden">
    <div className="px-5 py-4 border-b border-border">
      <h3 className="text-sm font-semibold text-text-primary">
        Top Hubs by Revenue
      </h3>
    </div>
    <table className="w-full text-sm">
      <thead className="bg-bg-elevated text-text-muted text-xs uppercase">
        <tr>
          <th className="px-5 py-3 text-left">#</th>
          <th className="px-5 py-3 text-left">Hub</th>
          <th className="px-5 py-3 text-left">Sales</th>
          <th className="px-5 py-3 text-left">Ticket Revenue</th>
          <th className="px-5 py-3 text-left">Extras Revenue</th>
          <th className="px-5 py-3 text-left">Total</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-border">
        {hubs.length === 0 ? (
          <tr>
            <td
              colSpan={6}
              className="px-5 py-10 text-center text-xs text-text-muted"
            >
              No revenue data yet
            </td>
          </tr>
        ) : (
          hubs.map((hub, index) => (
            <tr key={hub.hubId} className="hover:bg-bg-elevated transition">
              <td className="px-5 py-3 text-text-muted text-xs font-medium">
                {index + 1}
              </td>
              <td className="px-5 py-3">
                <div className="flex items-center gap-2">
                  {hub.hubImage ? (
                    <img
                      src={hub.hubImage}
                      alt=""
                      className="w-7 h-7 rounded-md object-cover"
                    />
                  ) : (
                    <div className="w-7 h-7 rounded-md bg-bg-elevated flex items-center justify-center">
                      <Building2 size={13} className="text-text-muted" />
                    </div>
                  )}
                  <span className="text-text-primary font-medium">
                    {hub.hubName}
                  </span>
                </div>
              </td>
              <td className="px-5 py-3 text-text-secondary">
                {hub.totalSales}
              </td>
              <td className="px-5 py-3 text-text-secondary">
                {formatCurrency(hub.ticketRevenue)}
              </td>
              <td className="px-5 py-3 text-text-secondary">
                {formatCurrency(hub.extrasRevenue)}
              </td>
              <td className="px-5 py-3">
                <span className="text-sm font-semibold text-primary">
                  {formatCurrency(hub.totalRevenue)}
                </span>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default TopHubsTable;
